var _style, _path, _g, _circle, _circle2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2499.6 2499.9",
    style: {
      enableBackground: "new 0 0 2499.6 2499.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "current",
    d: "M2499.6,1250c0,690.2-559.6,1249.8-1250.1,1249.9c-690,0-1249.6-559.7-1249.5-1250C-0.2,559.6,559.4,0,1249.7,0 S2499.6,559.7,2499.6,1250L2499.6,1250z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1052.1,2054.8h141.2v-242c38.7,0.8,76.2,1.1,112.9,1.1l-0.1,240.8h141.3l0.2-1596h-141.3v235.4 c-37.1,0-75.1,0.7-112.8,1.6v-237h-141.3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    fill: "#ffffff",
    cx: 1249.8,
    cy: 1250,
    r: 632.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1249.8,
    cy: 1250,
    r: 436.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1534,
    y: 985.2,
    className: "st0",
    width: 628.3,
    height: 556.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.8ee3da1917423843eff6edbf45069d8d.svg";
export { ForwardRef as ReactComponent };